
export default { name: "close-black" };
